import {
  BackstageOverrides,
} from '@backstage/core-components';
import {
  BackstageTheme,
  createTheme,
  lightTheme,
  darkTheme,
  shapes,
} from '@backstage/theme';

const createCustomThemeOverrides = (_theme: BackstageTheme): BackstageOverrides => {
  return {
    BackstageHeader: {
      header: {
        boxShadow: 'none',
        minHeight: '110px',
      },
      title: {
        fontWeight: 400,
      },
    },
  };
};

/**
 * Light theme for NavCan-branded developer portal.
 *  
 * @alpha
 */
export const NavCanLightTheme: BackstageTheme = {
  ...createTheme({
    palette: {
      ...lightTheme.palette,
      primary: {
        main: '#006eb0',
      },
      background: {
        default: '#eeeeee',
        paper: '#ffffff',
      },
      navigation: {
        ...lightTheme.palette.navigation,
        background: '#00529c',
        indicator: '#6781ba',
        color: '#ffffff',
        navItem: {
          hoverBackground: '#1e60a4',
        },
        submenu: {
          background: '#00529c',
        },
      }
    },
    fontFamily: 'Roboto,sans-serif',
    defaultPageTheme: 'home',
    pageTheme: {
      home: {
        colors: ['#00529c'],
        shape: shapes.wave,
        backgroundImage: 'linear-gradient(90deg, #00529c, #00a6dc)',
        fontColor: '#ffffff',
      },
    },
  }),
  overrides: {
    ...lightTheme.overrides,
    ...createCustomThemeOverrides(lightTheme),
  },
}

/**
 * Dark theme for NavCan-branded developer portal.
 *  
 * @alpha
 */
export const NavCanDarkTheme: BackstageTheme = {
  ...createTheme({
    palette: {
      ...darkTheme.palette,
      primary: {
        main: '#006eb0',
      },
      background: {
        default: '#121212',
        paper: '#1e1e1e',
      },
      navigation: {
        ...darkTheme.palette.navigation,
        background: '#00529c',
        indicator: '#6781ba',
        color: '#ffffff',
        navItem: {
          hoverBackground: '#1e60a4',
        },
        submenu: {
          background: '#00529c',
        },
      }
    },
    defaultPageTheme: 'home',
    pageTheme: {
      home: {
        colors: ['#00529c'],
        shape: shapes.wave,
        backgroundImage: 'linear-gradient(90deg, #00529c, #00a6dc)',
        fontColor: '#ffffff',
      },
    },
  }),
  overrides: {
    ...darkTheme.overrides,
    ...createCustomThemeOverrides(darkTheme),
  },
}
